import bannerImage from '../gfx/images/food01.jpeg'
import {Button, Col, Flex, Image, QRCode, Row, Space, Spin} from 'antd'
import {ReactComponent, $app} from '../app'
import {getAccountActiveCard, getPoints, getTotalVisitsForBasicStatus, getTotalVisitsForLobsterFriendStatus, isAccountLobsterFriend} from '../resources/AccountResource'
import BottomSheet from '../components/layout/BottomSheet'

import imageCard from '../gfx/card.svg'
import imageCloseSVG from '../gfx/close.svg'
import iconTick from '../gfx/tick.svg'
import iconPresent from '../gfx/present.svg'
import Reader from '../components/helpers/reader/Reader'
import BottomSheetCard from '../components/cards/BottomSheetCard'
import App from '../app/App'
import {addEvent} from '../resources/EventsResource'

function LobsterFriendStateIcon({ticked = false}) {
  return (<span className={`lobster-friend-state-icon ${ticked ? '_secondary' : ''}`}><Image src={(ticked) ? iconTick : iconPresent} preview={false}/></span>)
}

export default class HomePage extends ReactComponent {
  state = {
    activeReader: false,
    loading: true,
    points: 0,
    visits: null,
    isLobsterFriend: false,
    openQROfCardSheet: false,
    card: {
      number: '',
      valid_to: null
    }
  }

  async componentDidMount() {

    void this.getData()

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevState.isLobsterFriend === false && this.state.isLobsterFriend === true) {
      App.$toast('Výborně! Vítejte v Lobster Friend.')
    }
  }

  async getData() {

    try {

      const isLobsterFriend = await isAccountLobsterFriend()

      const visits = isLobsterFriend ? await getTotalVisitsForLobsterFriendStatus() : await getTotalVisitsForBasicStatus()

      const points = await getPoints()

      const card = await getAccountActiveCard()

      await this.updateState({
        isLobsterFriend,
        points,
        card,
        visits,
        loading: false
      })

    } catch (error) {
      console.log(error)
      void this.updateState({loading: false})
    }

  }

  async addVisit(external_id) {

    // TODO: implenet external id check

    if(external_id === null)
      return

    const res = await addEvent(external_id)

    void this.updateState({loading: true})

    await this.getData()

  }

  render() {
    return (
      <>
        <Spin spinning={this.state.loading} size="large">
          <section className="full-height">
            <div className="image-container h100">
              <img src={bannerImage} className={''}/>
            </div>


            {!this.state.isLobsterFriend ?

              <BottomSheetCard active={!this.state.loading} className="_background-secondary">

                <Row gutter={[48, 32]} className="ta-center pt-2">
                  <Col span={24}>

                    <Space size={22} className="pb-1">
                      {[...Array(5)].map((_, i) =>
                        <LobsterFriendStateIcon key={i} ticked={i < this.state.visits}/>
                      )}
                    </Space>

                  </Col>
                  <Col span={24}>

                    <Button
                      type="primary"
                      onClick={() => {
                        void this.updateState({activeReader: true})
                      }}
                    >Načíst návštěvu</Button>

                    <Reader
                      active={this.state.activeReader}
                      onClose={(res) => {
                        void this.updateState({activeReader: false})
                        void this.addVisit(res)
                      }}
                    />

                    <p className="mt-3 _grey-primary-text fs-small">*Po 5 návštěvách se stanete Lobster friend</p>
                  </Col>
                </Row>
              </BottomSheetCard>

              :

              <BottomSheetCard active={!this.state.loading}>

                <p className="strong"><span className="_secondary-text pr-1">Cashback:</span> 10%</p>
                <p className="strong"><span className="_secondary-text pr-1">Počet návštěv:</span> {this.state.visits}</p>
                <p className="strong"><span className="_secondary-text pr-1">Stav konta:</span> {this.state.points} {$app.$tc('points', this.state.points)}</p>
                <div className="ta-center mt-3">
                  <Button
                    type="primary"
                    onClick={() => {
                      void this.updateState({openQROfCardSheet: true})
                    }}
                    icon={<img src={imageCard} alt=""/>}
                    iconPosition="end"
                  >Karta</Button>
                </div>

              </BottomSheetCard>
            }

            {this.state.card?.number &&

              <BottomSheet
                active={this.state.openQROfCardSheet}
                onClose={() => {
                  void this.updateState({openQROfCardSheet: false})
                }}
                iconClose={imageCloseSVG}
                className="background-primary bs-padding">

                <>
                  <Flex align="center" vertical>
                    <h3 className="h3 _secondary-text">Karta Lobster Friends</h3>


                    <QRCode
                      value={this.state.card?.number}
                      color="#ffffff"
                      errorLevel="M"
                    />


                  </Flex>
                  <p className="ta-center fs-smaller _background-primary-text">{this.state.card.number}</p>
                </>

              </BottomSheet>

            }

          </section>
        </Spin>
      </>
    )
  }
}